
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured-indices",
      function () {
        return require("private-next-pages/featured-indices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured-indices"])
      });
    }
  